__turbopack_context__.v({
  "aboucontentborder": "upsc-ias-ips-admission-module__vPXKpG__aboucontentborder",
  "aboutSection": "upsc-ias-ips-admission-module__vPXKpG__aboutSection",
  "aboutbox1": "upsc-ias-ips-admission-module__vPXKpG__aboutbox1",
  "aboutparagraph1": "upsc-ias-ips-admission-module__vPXKpG__aboutparagraph1",
  "aboutparagraph2": "upsc-ias-ips-admission-module__vPXKpG__aboutparagraph2",
  "aboutparagraph3": "upsc-ias-ips-admission-module__vPXKpG__aboutparagraph3",
  "acheivergreyrank": "upsc-ias-ips-admission-module__vPXKpG__acheivergreyrank",
  "acheivername": "upsc-ias-ips-admission-module__vPXKpG__acheivername",
  "acheivername2": "upsc-ias-ips-admission-module__vPXKpG__acheivername2",
  "acheiverrank": "upsc-ias-ips-admission-module__vPXKpG__acheiverrank",
  "acheiverrank1": "upsc-ias-ips-admission-module__vPXKpG__acheiverrank1",
  "acheiverrank2": "upsc-ias-ips-admission-module__vPXKpG__acheiverrank2",
  "acheiverrank3": "upsc-ias-ips-admission-module__vPXKpG__acheiverrank3",
  "acheiverranks": "upsc-ias-ips-admission-module__vPXKpG__acheiverranks",
  "acheiverresult": "upsc-ias-ips-admission-module__vPXKpG__acheiverresult",
  "acheivertitle": "upsc-ias-ips-admission-module__vPXKpG__acheivertitle",
  "acheiverwhiterank": "upsc-ias-ips-admission-module__vPXKpG__acheiverwhiterank",
  "achievementBox": "upsc-ias-ips-admission-module__vPXKpG__achievementBox",
  "active": "upsc-ias-ips-admission-module__vPXKpG__active",
  "addmissionform": "upsc-ias-ips-admission-module__vPXKpG__addmissionform",
  "admincontent": "upsc-ias-ips-admission-module__vPXKpG__admincontent",
  "badge": "upsc-ias-ips-admission-module__vPXKpG__badge",
  "bangmainTitle": "upsc-ias-ips-admission-module__vPXKpG__bangmainTitle",
  "batchrank2": "upsc-ias-ips-admission-module__vPXKpG__batchrank2",
  "batcname2": "upsc-ias-ips-admission-module__vPXKpG__batcname2",
  "bbadge": "upsc-ias-ips-admission-module__vPXKpG__bbadge",
  "bestbg": "upsc-ias-ips-admission-module__vPXKpG__bestbg",
  "bestbg1": "upsc-ias-ips-admission-module__vPXKpG__bestbg1",
  "bgpink": "upsc-ias-ips-admission-module__vPXKpG__bgpink",
  "bground": "upsc-ias-ips-admission-module__vPXKpG__bground",
  "boxborder": "upsc-ias-ips-admission-module__vPXKpG__boxborder",
  "branchBtn": "upsc-ias-ips-admission-module__vPXKpG__branchBtn",
  "brochure": "upsc-ias-ips-admission-module__vPXKpG__brochure",
  "brochurebtn": "upsc-ias-ips-admission-module__vPXKpG__brochurebtn",
  "brochuretxt": "upsc-ias-ips-admission-module__vPXKpG__brochuretxt",
  "captcha": "upsc-ias-ips-admission-module__vPXKpG__captcha",
  "card-container": "upsc-ias-ips-admission-module__vPXKpG__card-container",
  "card-icon": "upsc-ias-ips-admission-module__vPXKpG__card-icon",
  "cardBox": "upsc-ias-ips-admission-module__vPXKpG__cardBox",
  "cardTop": "upsc-ias-ips-admission-module__vPXKpG__cardTop",
  "cardbox1": "upsc-ias-ips-admission-module__vPXKpG__cardbox1",
  "carouselImg": "upsc-ias-ips-admission-module__vPXKpG__carouselImg",
  "carouselWrapper": "upsc-ias-ips-admission-module__vPXKpG__carouselWrapper",
  "checkboxcontent": "upsc-ias-ips-admission-module__vPXKpG__checkboxcontent",
  "chooseCard": "upsc-ias-ips-admission-module__vPXKpG__chooseCard",
  "choosecircle": "upsc-ias-ips-admission-module__vPXKpG__choosecircle",
  "circleGlow": "upsc-ias-ips-admission-module__vPXKpG__circleGlow",
  "classacheiverrank": "upsc-ias-ips-admission-module__vPXKpG__classacheiverrank",
  "classesborder": "upsc-ias-ips-admission-module__vPXKpG__classesborder",
  "classesborder2": "upsc-ias-ips-admission-module__vPXKpG__classesborder2",
  "colbox": "upsc-ias-ips-admission-module__vPXKpG__colbox",
  "contactBox": "upsc-ias-ips-admission-module__vPXKpG__contactBox",
  "contactLabel": "upsc-ias-ips-admission-module__vPXKpG__contactLabel",
  "contactValue": "upsc-ias-ips-admission-module__vPXKpG__contactValue",
  "contactheader": "upsc-ias-ips-admission-module__vPXKpG__contactheader",
  "content": "upsc-ias-ips-admission-module__vPXKpG__content",
  "content2": "upsc-ias-ips-admission-module__vPXKpG__content2",
  "courseList": "upsc-ias-ips-admission-module__vPXKpG__courseList",
  "coursesimg": "upsc-ias-ips-admission-module__vPXKpG__coursesimg",
  "csatborder": "upsc-ias-ips-admission-module__vPXKpG__csatborder",
  "ctaCard": "upsc-ias-ips-admission-module__vPXKpG__ctaCard",
  "ctaSection": "upsc-ias-ips-admission-module__vPXKpG__ctaSection",
  "ctaText": "upsc-ias-ips-admission-module__vPXKpG__ctaText",
  "ctaTitle": "upsc-ias-ips-admission-module__vPXKpG__ctaTitle",
  "curntbutton": "upsc-ias-ips-admission-module__vPXKpG__curntbutton",
  "delhiacheiver": "upsc-ias-ips-admission-module__vPXKpG__delhiacheiver",
  "delhibox": "upsc-ias-ips-admission-module__vPXKpG__delhibox",
  "delhiform": "upsc-ias-ips-admission-module__vPXKpG__delhiform",
  "description": "upsc-ias-ips-admission-module__vPXKpG__description",
  "directionline": "upsc-ias-ips-admission-module__vPXKpG__directionline",
  "dot": "upsc-ias-ips-admission-module__vPXKpG__dot",
  "dot1": "upsc-ias-ips-admission-module__vPXKpG__dot1",
  "dot2": "upsc-ias-ips-admission-module__vPXKpG__dot2",
  "emibutton": "upsc-ias-ips-admission-module__vPXKpG__emibutton",
  "facultyborder3": "upsc-ias-ips-admission-module__vPXKpG__facultyborder3",
  "facultyborder4": "upsc-ias-ips-admission-module__vPXKpG__facultyborder4",
  "featureCard": "upsc-ias-ips-admission-module__vPXKpG__featureCard",
  "featureCard1": "upsc-ias-ips-admission-module__vPXKpG__featureCard1",
  "featureGrid": "upsc-ias-ips-admission-module__vPXKpG__featureGrid",
  "featureItem": "upsc-ias-ips-admission-module__vPXKpG__featureItem",
  "featureSection": "upsc-ias-ips-admission-module__vPXKpG__featureSection",
  "featureTitle": "upsc-ias-ips-admission-module__vPXKpG__featureTitle",
  "featurebox": "upsc-ias-ips-admission-module__vPXKpG__featurebox",
  "featurecnt": "upsc-ias-ips-admission-module__vPXKpG__featurecnt",
  "featuredescription": "upsc-ias-ips-admission-module__vPXKpG__featuredescription",
  "featuretitle": "upsc-ias-ips-admission-module__vPXKpG__featuretitle",
  "flex1": "upsc-ias-ips-admission-module__vPXKpG__flex1",
  "forestbutton": "upsc-ias-ips-admission-module__vPXKpG__forestbutton",
  "forestrank": "upsc-ias-ips-admission-module__vPXKpG__forestrank",
  "foresttitle": "upsc-ias-ips-admission-module__vPXKpG__foresttitle",
  "formstar": "upsc-ias-ips-admission-module__vPXKpG__formstar",
  "founderbg": "upsc-ias-ips-admission-module__vPXKpG__founderbg",
  "founderbg1": "upsc-ias-ips-admission-module__vPXKpG__founderbg1",
  "founderbg2": "upsc-ias-ips-admission-module__vPXKpG__founderbg2",
  "foundertitle": "upsc-ias-ips-admission-module__vPXKpG__foundertitle",
  "foundertitle1": "upsc-ias-ips-admission-module__vPXKpG__foundertitle1",
  "glassCard": "upsc-ias-ips-admission-module__vPXKpG__glassCard",
  "gsbutton": "upsc-ias-ips-admission-module__vPXKpG__gsbutton",
  "gspcmbg": "upsc-ias-ips-admission-module__vPXKpG__gspcmbg",
  "gstitle": "upsc-ias-ips-admission-module__vPXKpG__gstitle",
  "heroCard": "upsc-ias-ips-admission-module__vPXKpG__heroCard",
  "heroTitle": "upsc-ias-ips-admission-module__vPXKpG__heroTitle",
  "highlight": "upsc-ias-ips-admission-module__vPXKpG__highlight",
  "highlightCard": "upsc-ias-ips-admission-module__vPXKpG__highlightCard",
  "hyderabadcon": "upsc-ias-ips-admission-module__vPXKpG__hyderabadcon",
  "hyderabadtitle": "upsc-ias-ips-admission-module__vPXKpG__hyderabadtitle",
  "hyderabadtitle1": "upsc-ias-ips-admission-module__vPXKpG__hyderabadtitle1",
  "icon": "upsc-ias-ips-admission-module__vPXKpG__icon",
  "iconPulse": "upsc-ias-ips-admission-module__vPXKpG__iconPulse",
  "iconWrapper": "upsc-ias-ips-admission-module__vPXKpG__iconWrapper",
  "iconimg": "upsc-ias-ips-admission-module__vPXKpG__iconimg",
  "imageCard": "upsc-ias-ips-admission-module__vPXKpG__imageCard",
  "imagee": "upsc-ias-ips-admission-module__vPXKpG__imagee",
  "img": "upsc-ias-ips-admission-module__vPXKpG__img",
  "infoCard": "upsc-ias-ips-admission-module__vPXKpG__infoCard",
  "invalidCheck2": "upsc-ias-ips-admission-module__vPXKpG__invalidCheck2",
  "item": "upsc-ias-ips-admission-module__vPXKpG__item",
  "mainTitle": "upsc-ias-ips-admission-module__vPXKpG__mainTitle",
  "mainsmock": "upsc-ias-ips-admission-module__vPXKpG__mainsmock",
  "marathon": "upsc-ias-ips-admission-module__vPXKpG__marathon",
  "marqueeItem": "upsc-ias-ips-admission-module__vPXKpG__marqueeItem",
  "marqueeMove": "upsc-ias-ips-admission-module__vPXKpG__marqueeMove",
  "marqueeOneByOne": "upsc-ias-ips-admission-module__vPXKpG__marqueeOneByOne",
  "marqueeTrack": "upsc-ias-ips-admission-module__vPXKpG__marqueeTrack",
  "marqueeWrapper": "upsc-ias-ips-admission-module__vPXKpG__marqueeWrapper",
  "mockutton": "upsc-ias-ips-admission-module__vPXKpG__mockutton",
  "nav-item": "upsc-ias-ips-admission-module__vPXKpG__nav-item",
  "nav-link": "upsc-ias-ips-admission-module__vPXKpG__nav-link",
  "nav-pills": "upsc-ias-ips-admission-module__vPXKpG__nav-pills",
  "nav-tabs": "upsc-ias-ips-admission-module__vPXKpG__nav-tabs",
  "newbutton": "upsc-ias-ips-admission-module__vPXKpG__newbutton",
  "normalbutton": "upsc-ias-ips-admission-module__vPXKpG__normalbutton",
  "normalbutton1": "upsc-ias-ips-admission-module__vPXKpG__normalbutton1",
  "normalbutton2": "upsc-ias-ips-admission-module__vPXKpG__normalbutton2",
  "normalbutton3": "upsc-ias-ips-admission-module__vPXKpG__normalbutton3",
  "numberbold": "upsc-ias-ips-admission-module__vPXKpG__numberbold",
  "obtionalbutton": "upsc-ias-ips-admission-module__vPXKpG__obtionalbutton",
  "oneplusbox": "upsc-ias-ips-admission-module__vPXKpG__oneplusbox",
  "optionabutton": "upsc-ias-ips-admission-module__vPXKpG__optionabutton",
  "optionalbutton": "upsc-ias-ips-admission-module__vPXKpG__optionalbutton",
  "pagemaintitle": "upsc-ias-ips-admission-module__vPXKpG__pagemaintitle",
  "pagemaintitle2": "upsc-ias-ips-admission-module__vPXKpG__pagemaintitle2",
  "para": "upsc-ias-ips-admission-module__vPXKpG__para",
  "paybill": "upsc-ias-ips-admission-module__vPXKpG__paybill",
  "paybill1": "upsc-ias-ips-admission-module__vPXKpG__paybill1",
  "paybtn": "upsc-ias-ips-admission-module__vPXKpG__paybtn",
  "paybutton": "upsc-ias-ips-admission-module__vPXKpG__paybutton",
  "phone": "upsc-ias-ips-admission-module__vPXKpG__phone",
  "phoneiconcss": "upsc-ias-ips-admission-module__vPXKpG__phoneiconcss",
  "plus": "upsc-ias-ips-admission-module__vPXKpG__plus",
  "plusbutton": "upsc-ias-ips-admission-module__vPXKpG__plusbutton",
  "prebg": "upsc-ias-ips-admission-module__vPXKpG__prebg",
  "prebg1": "upsc-ias-ips-admission-module__vPXKpG__prebg1",
  "prebutton": "upsc-ias-ips-admission-module__vPXKpG__prebutton",
  "prelimbutton": "upsc-ias-ips-admission-module__vPXKpG__prelimbutton",
  "prelimtitle": "upsc-ias-ips-admission-module__vPXKpG__prelimtitle",
  "premiumCard": "upsc-ias-ips-admission-module__vPXKpG__premiumCard",
  "pretitle": "upsc-ias-ips-admission-module__vPXKpG__pretitle",
  "priceBox": "upsc-ias-ips-admission-module__vPXKpG__priceBox",
  "primaryBtn": "upsc-ias-ips-admission-module__vPXKpG__primaryBtn",
  "program": "upsc-ias-ips-admission-module__vPXKpG__program",
  "program1": "upsc-ias-ips-admission-module__vPXKpG__program1",
  "radiobutton": "upsc-ias-ips-admission-module__vPXKpG__radiobutton",
  "redunderline": "upsc-ias-ips-admission-module__vPXKpG__redunderline",
  "redunderline2": "upsc-ias-ips-admission-module__vPXKpG__redunderline2",
  "redunderlinealink": "upsc-ias-ips-admission-module__vPXKpG__redunderlinealink",
  "ribbon": "upsc-ias-ips-admission-module__vPXKpG__ribbon",
  "roadmapContainer": "upsc-ias-ips-admission-module__vPXKpG__roadmapContainer",
  "rotateGlow": "upsc-ias-ips-admission-module__vPXKpG__rotateGlow",
  "sadhana": "upsc-ias-ips-admission-module__vPXKpG__sadhana",
  "sadhanabg": "upsc-ias-ips-admission-module__vPXKpG__sadhanabg",
  "sadhanatitle": "upsc-ias-ips-admission-module__vPXKpG__sadhanatitle",
  "sadhanatitle1": "upsc-ias-ips-admission-module__vPXKpG__sadhanatitle1",
  "scheduleItem": "upsc-ias-ips-admission-module__vPXKpG__scheduleItem",
  "scheduleSection": "upsc-ias-ips-admission-module__vPXKpG__scheduleSection",
  "scrolldiv": "upsc-ias-ips-admission-module__vPXKpG__scrolldiv",
  "scrollparent": "upsc-ias-ips-admission-module__vPXKpG__scrollparent",
  "sectionDesc": "upsc-ias-ips-admission-module__vPXKpG__sectionDesc",
  "sectionTitle": "upsc-ias-ips-admission-module__vPXKpG__sectionTitle",
  "sectionWrapper": "upsc-ias-ips-admission-module__vPXKpG__sectionWrapper",
  "sectioncont": "upsc-ias-ips-admission-module__vPXKpG__sectioncont",
  "sectiondescription": "upsc-ias-ips-admission-module__vPXKpG__sectiondescription",
  "sectionredtitle": "upsc-ias-ips-admission-module__vPXKpG__sectionredtitle",
  "sectionredtitle1": "upsc-ias-ips-admission-module__vPXKpG__sectionredtitle1",
  "sectionsubtitle": "upsc-ias-ips-admission-module__vPXKpG__sectionsubtitle",
  "sectionsubtitle1": "upsc-ias-ips-admission-module__vPXKpG__sectionsubtitle1",
  "sectiontitle": "upsc-ias-ips-admission-module__vPXKpG__sectiontitle",
  "sectiontitle1": "upsc-ias-ips-admission-module__vPXKpG__sectiontitle1",
  "shabir": "upsc-ias-ips-admission-module__vPXKpG__shabir",
  "show": "upsc-ias-ips-admission-module__vPXKpG__show",
  "sliderredbutton": "upsc-ias-ips-admission-module__vPXKpG__sliderredbutton",
  "startegy": "upsc-ias-ips-admission-module__vPXKpG__startegy",
  "startegy1": "upsc-ias-ips-admission-module__vPXKpG__startegy1",
  "statCircle": "upsc-ias-ips-admission-module__vPXKpG__statCircle",
  "statcircle": "upsc-ias-ips-admission-module__vPXKpG__statcircle",
  "statlabel": "upsc-ias-ips-admission-module__vPXKpG__statlabel",
  "statnumber": "upsc-ias-ips-admission-module__vPXKpG__statnumber",
  "statsRow": "upsc-ias-ips-admission-module__vPXKpG__statsRow",
  "tabactive": "upsc-ias-ips-admission-module__vPXKpG__tabactive",
  "tableheading1": "upsc-ias-ips-admission-module__vPXKpG__tableheading1",
  "tablepara1": "upsc-ias-ips-admission-module__vPXKpG__tablepara1",
  "tablinks": "upsc-ias-ips-admission-module__vPXKpG__tablinks",
  "tabscrollclass": "upsc-ias-ips-admission-module__vPXKpG__tabscrollclass",
  "tabsection": "upsc-ias-ips-admission-module__vPXKpG__tabsection",
  "tickList": "upsc-ias-ips-admission-module__vPXKpG__tickList",
  "title": "upsc-ias-ips-admission-module__vPXKpG__title",
  "ulclass": "upsc-ias-ips-admission-module__vPXKpG__ulclass",
  "ulliclass": "upsc-ias-ips-admission-module__vPXKpG__ulliclass",
  "ullispan": "upsc-ias-ips-admission-module__vPXKpG__ullispan",
  "upsc-ias-ips-admission_flex1__px8So": "upsc-ias-ips-admission-module__vPXKpG__upsc-ias-ips-admission_flex1__px8So",
  "viewbutton": "upsc-ias-ips-admission-module__vPXKpG__viewbutton",
  "viewbutton2": "upsc-ias-ips-admission-module__vPXKpG__viewbutton2",
  "viewbuttonalink": "upsc-ias-ips-admission-module__vPXKpG__viewbuttonalink",
  "visitNote": "upsc-ias-ips-admission-module__vPXKpG__visitNote",
  "whySection": "upsc-ias-ips-admission-module__vPXKpG__whySection",
  "whyboxboxheight2": "upsc-ias-ips-admission-module__vPXKpG__whyboxboxheight2",
  "whysia": "upsc-ias-ips-admission-module__vPXKpG__whysia",
});
